module.exports = __webpack_public_path__ + "static/coliving-bath-2-8fb5206d90827d2f13ada69d2b040c45.jpg";